import React from 'react';
import NavBar from './NavBar.jsx';
import ReactDOM from 'react-dom';

import Ajax from './AJAX.jsx';
import InteractiveTable from './InteractiveTable.jsx';
import UpdateDataForm from './UpdateDataForm.jsx';
import * as tools from "./tools.jsx";
import {DropDownMultiSelector} from "./DropDownSelector.jsx";
import {ConfirmModal} from "./ConfirmModal.jsx";
import {SelectBool} from "./genericElements.jsx";

class ContextList extends React.Component {
   constructor(props)
   {
      super(props);
      this.state = {
         data_contexts: [],
         data_users: [],
         data_roles: [],
         data_playlists: [],
         data_ContextsWithPlaylistCount: [],
      }

      this.updatePublic = function(e)
      {
         console.log("Mangler måde at håndtere dette. Måske ved at lave row-jsx-klasser")
         console.log(e.target.value);
      }.bind(this);

      var clickedPlaylists = function(con)
      {
         var restrictions = {'context_id':con.context_id};
         this.props.changePageCallback({id:"playlists", name:"playlists in '" + con.name + "'", restrictions   });
      }.bind(this);
      
      var clickedComps = function(con)
      {
         var restrictions = {'context_id':con.context_id};
         this.props.changePageCallback({id:"compositions", name:"compositions in '" + con.name + "'", restrictions   });
      }.bind(this);

      var clickedUserCount = function(con)
      {
         var restrictions = {'context_id':con.context_id};
         this.props.changePageCallback({id:"users", name:"users in '" + con.name + "'", restrictions});
      }.bind(this);

      this.clickedEdit = function(con)
      {
         const self = this;

         var onEditSave = function(editedData)
         {
            if(editedData == null)
            {
               self.props.appCallbacks.popModal();
            }
            else
            {
               var updateDoneCB = function(responseObj)
               {
                  if(responseObj.success)
                  {
                     self.refreshData();
                     self.props.appCallbacks.popModal();
                  }
                  else
                  {
                     self.props.appCallbacks.showResponseErr(responseObj, "Edit Context Error");
                     
                  }
               };

               self.props.appCallbacks.performAjaxRequest("contexts/" + con.context_id, "PUT", editedData, updateDoneCB);
            }        
         }
         
         const fieldsToEdit = {
            name: con.name,
            active: con.active,
            public: con.public,
            owner: con.owner_id,
            canCreatePlaylistsInApp: con.canCreatePlaylistsInApp,
         }


         /*const drawFuncObjects = {
            owner:{objects:}
         }*/
         
         const modalProps = {
            saveCallback:onEditSave,
            heading:'Edit Context',
            data:fieldsToEdit,
            drawFuncs:{owner:DropDownMultiSelector,
               public: SelectBool,
               active: SelectBool,
               canCreatePlaylistsInApp: SelectBool},
            drawFuncObjects:{owner:{objects: self.getPossibleOwners(), selectSingle:true}},
         }

         this.props.appCallbacks.pushModal({modalClass:UpdateDataForm, modalProps:modalProps});

         /*this.props.appCallbacks.setModal(<UpdateDataForm saveCallback={onEditSave}
            heading='Edit Context Data' key={'hans'} data={fieldsToEdit} />);*/
           
      }.bind(this);

      this.clickedDelete = function(con)
      {
         const self = this;

         const onConfirmDelete = ()=>
         {
            const onServerDelete = (response) => {
               if(response.success)
               {
                  self.refreshData();
               }
               else
               {
                  self.props.appCallbacks.showResponseErr(response, "Failed deleting context");
               }
            }
            self.props.appCallbacks.performAjaxRequest('contexts/' + con.context_id, "DELETE", null, onServerDelete, false);
         }

         const onCancelDelete = ()=>{};

         const modalProps = {
            heading: "Confirm Delete",
            msg:"Delete context: " + con.name + " ?",
            onConfirm:onConfirmDelete,
            popModal: self.props.appCallbacks.popModal,
         }
         self.props.appCallbacks.pushModal({modalClass:ConfirmModal, modalProps:modalProps});
      }.bind(this);

      this.contextClickMap = 
      {
         playlists:clickedPlaylists,
         users:clickedUserCount,
         compositions:clickedComps
      }

      this.extraBtns = [
         {
            name:"edit",
            click: this.clickedEdit
         },
         {
            name:"delete",
            click: this.clickedDelete
         }
      ]
   }

   refreshData()
   {

      const checkResponseForErr = (response)=>
      {
         if(!response.success)
         {
            const newErrors = [...this.state.errors, ...response.error];
            this.setState({errors:newErrors});
         }
         return response.success;
      }

      this.props.appCallbacks.performAjaxRequest("contexts", "GET", null,
         tools.getSetBaseDataFunc(this, "data_contexts").bind(this));

      this.props.appCallbacks.performAjaxRequest("users", "GET", null,
         tools.getSetBaseDataFunc(this, "data_users").bind(this));

      this.props.appCallbacks.performAjaxRequest("roles", "GET", null,
         tools.getSetBaseDataFunc(this, "data_roles").bind(this));

       this.props.appCallbacks.performAjaxRequest("playlists", "GET", null,
         tools.getSetBaseDataFunc(this, "data_playlists").bind(this));
        

   }

   componentDidMount()
   {
      this.refreshData();
   }

   componentWillUpdate(nextProps, nextState)
   {
      //Add playlist count to contexts
      if(this.state.data_contexts != nextState.data_contexts ||
         this.state.data_playlists != nextState.data_playlists)
      {
         const newDataConWPL = nextState.data_contexts.map((d_c)=>{
            const plCount = nextState.data_playlists.filter((pl)=>{return pl.context_id == d_c.context_id;}).length;;
            return {...d_c, playlists:plCount};});

         this.setState({data_ContextsWithPlaylistCount:newDataConWPL});
      }
   }

   getPossibleOwners()
   {
      const rolesThatCreateContexts = this.state.data_roles.filter((r)=>r.create_contexts != 0);

      const usersThatCreateContexts = this.state.data_users.filter((u)=>
         rolesThatCreateContexts.find((r)=>r.role_id == u.role));

      return usersThatCreateContexts.map((u)=>{return({id:u.user_id, name:u.name});});
   }

   clickedAddNewContext()
   {
      const self = this;

      const onNewContextCB = (newCon)=>
      {
         if(newCon)
         {
            const newCOnUploaded = (response)=>
            {
               if(response.success)
               {     
                  self.props.appCallbacks.popModal();
                  self.refreshData();
               }
               else
               {
                  self.props.appCallbacks.showResponseErr(response, "Add Context");
               }
            }
            this.props.appCallbacks.performAjaxRequest('contexts', "POST", newCon, newCOnUploaded.bind(this), false);
         }
         else
         {
            self.props.appCallbacks.popModal();
         }
      }
      const emptyContext =
      {
         name:"",
         public:0,
         active:0,
         owner: Number(this.props.user.user_id),
      }

      const drawFunctions =
      {
         owner:DropDownMultiSelector,
         public:SelectBool,
         active: SelectBool
      }

      const rolesThatCreateContexts = this.state.data_roles.filter((r)=>r.create_contexts != 0);

      const usersThatCreateContexts = this.state.data_users.filter((u)=>
         rolesThatCreateContexts.find((r)=>r.role_id == u.role));

      const userObjects = usersThatCreateContexts.map((u)=>{return({id:u.user_id, name:u.name});});
         
      var modalProps = {
            saveCallback:onNewContextCB,
            heading:"Add new Context",
            data:emptyContext,
            drawFuncs:drawFunctions,
            drawFuncObjects:{owner:{objects: self.getPossibleOwners(), selectSingle:true}},
         };
    
      this.props.appCallbacks.pushModal({modalClass:UpdateDataForm, modalProps:modalProps});
      
   }

   getInterpreter()
   {
      return {
         active:(val)=>val == 0 ? "NO" : "YES",
         public:(val)=>val == 0 ? "NO" : "YES",
         canCreatePlaylistsInApp:(val)=>val == 0 ? "NO" : "YES"
      }
   }
   render() {
      

      var tableStyle1 = {
         background: '#DDDDDD',
         padding: 5 
      }
      
      var tableStyle2 = Object.assign({},tableStyle1);

      tableStyle2.background = '#F0F0F0';

      var divStyle =
      {
         display:'inline'
      }
      return (
         <div style={divStyle}>
            <h1> Contexts </h1>
            <InteractiveTable interpreter={this.getInterpreter()}rowObjects={this.state.data_ContextsWithPlaylistCount} hideColumns={["owner_id"]} extraBtns={this.extraBtns} clickMap={this.contextClickMap} />
            <button onClick={this.clickedAddNewContext.bind(this)}>Add Context</button>
         </div>
      );
   }
}

export default ContextList ;


// WEBPACK FOOTER //
// ./js/contextList.jsx